import { render, staticRenderFns } from "./EmailAreas.vue?vue&type=template&id=c034b118"
import script from "./EmailAreas.vue?vue&type=script&lang=js"
export * from "./EmailAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports